import {
  Client,
  STORAGE_TTL,
  StoredConversation,
  storedConversations,
} from '@stripe-internal/conversations-client';

export const STORED_TTL: STORAGE_TTL = {value: 30, unit: 'minutes'};

export function getStoredConversation(): StoredConversation | null {
  const stored = storedConversations({limit: 1, ttl: STORED_TTL});

  if (stored.length === 0) {
    return null;
  }

  return stored[0];
}

export async function getInProgressStoredConversation({
  storedConversation,
  client,
  audience,
  entryPoint,
  universalHelpFindConversationByEntryPoint,
}: {
  storedConversation?: StoredConversation;
  client: Client;
  audience: string;
  entryPoint: string;
  universalHelpFindConversationByEntryPoint: boolean;
}): Promise<StoredConversation | null> {
  let stored: StoredConversation | undefined | null;
  if (storedConversation) {
    stored = storedConversation;
  } else {
    stored = getStoredConversation();
  }

  if (
    !stored ||
    (universalHelpFindConversationByEntryPoint &&
      stored.data?.context?.entryPoint !== entryPoint) ||
    (!universalHelpFindConversationByEntryPoint &&
      stored.data?.context?.audience !== audience)
  ) {
    return null;
  }

  const inProgressResp = await client.inProgress({
    conversationId: stored.id,
    context: stored.data?.context,
  });

  if ('error' in inProgressResp) {
    return null;
  }

  if (
    inProgressResp.data.inProgress &&
    inProgressResp.data.conversationId === stored.id
  ) {
    return stored;
  }

  return null;
}
